import { CarrierSelector } from "~/components/CarrierSelector";
import { PickupPointSelector } from "~/components/PickupPointSelector";
import classNames from "classnames";
import { CartAddressInput } from "~/components/CartAddressInput";
import { useStoreCart } from "./useStoreCart";
import { Text } from "~/components/Text";
import { StrapiStoreDeliveryType } from "~/shared-types";

type Props = {
  className?: string;
  storeDeliveryType: StrapiStoreDeliveryType;
};

export const DeliverySection = ({ className, storeDeliveryType }: Props) => {
  const { currentDeliveryType } = useStoreCart();

  if (currentDeliveryType === "pickup") return null;

  return (
    <div className={classNames(className)}>
      <hr className="text-secondary-200" />
      <Text className="text-xl mt-12">Levering</Text>
      <CartAddressInput className="mt-4" />
      {storeDeliveryType === "shipmondo" &&
        (currentDeliveryType === "shipmondo" ||
          currentDeliveryType === "freeShipping") && (
          <>
            <CarrierSelector className="mt-10" />
            <PickupPointSelector className="mt-10" />
          </>
        )}
    </div>
  );
};
